import React from 'react';
import { Button } from '../ui/button';

const PRESETS = [['30 days', 30], ['90 days', 90], ['1 year', 365], ['All history', null]];

export const presetStart = (days) => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  d.setHours(0, 0, 0, 0);
  return d;
};

// Which preset matches the current filters (null = All history, number = days,
// undefined = custom range so nothing highlights).
const activeDays = (startTime, endTime) => {
  if (endTime) return undefined;
  if (!startTime) return null;
  const t = new Date(startTime).getTime();
  for (const [, days] of PRESETS) {
    if (days && Math.abs(t - presetStart(days).getTime()) < 60000) return days;
  }
  return undefined;
};

export const LogbookQuickRange = ({ startTime, endTime, onSelect, testIdPrefix, className = '' }) => {
  const active = activeDays(startTime, endTime);
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid={`${testIdPrefix}-presets`}>
      <span className="text-[11px] text-muted-foreground mr-1">Quick range:</span>
      {PRESETS.map(([label, days]) => {
        const isActive = active === days;
        return (
          <Button
            key={label}
            size="sm"
            variant={isActive ? 'default' : 'outline'}
            className={`h-7 px-2 text-xs ${isActive ? 'bg-[#2563eb] hover:bg-[#1d4ed8] text-white' : ''}`}
            onClick={() => onSelect(days ? presetStart(days) : null)}
            data-testid={`${testIdPrefix}-preset-${days || 'all'}`}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};
